import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import './IntroPage.scss'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import HeaderMenu from '../../Components/Commons/HeaderMenu'
import ReactGA from 'react-ga'
import MetaTags from 'react-meta-tags'

class IntroPage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            description: null,
            id: null,
        }
    }

    UNSAFE_componentWillMount() {
        this.loadProject()
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    loadProject = () => {
        axios
            .get(`${BACKEND_HOST}/projects/${this.props.cookies.get('project')}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res.data)

                this.setState({
                    description: res.data.description,
                    id: res.data._id,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        if (this.state.description !== null) {
            const codes = this.state.description
            return (
                <div>
                    <MetaTags>
                        <title>투명한 집짓기 하우스플래너 - 우리 집을 소개합니다. </title>
                    </MetaTags>
                    <HeaderMenu />
                    <div className="section_wrap section_wrap_menu">
                        <div>
                            {this.state.description !== '' ? (
                                <div className="intro_page_wrap common_list">
                                    <div className="top_wrap common_wrap">
                                        <h1>계획</h1>
                                        <h2>법규 현황, 설계 컨셉등 대한 계획을 확인할 수 있습니다.</h2>
                                        <Link
                                            to="/intro/detail"
                                            onClick={() => {
                                                ReactGA.event({ category: '하우스플랜', action: '설계도보기' })
                                            }}>
                                            <div className="upload_btn">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14"
                                                    height="14"
                                                    viewBox="0 0 14 14">
                                                    <g fill="none" fillRule="evenodd" stroke="#24524A">
                                                        <rect
                                                            width="12.7"
                                                            height="12.7"
                                                            x=".65"
                                                            y=".65"
                                                            strokeWidth="1.3"
                                                            rx="2"
                                                        />
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeWidth="1.2"
                                                            d="M3.5 7h7M3.5 4.25h7M3.5 9.8h7"
                                                        />
                                                    </g>
                                                </svg>
                                                설계도 보기
                                            </div>
                                        </Link>
                                    </div>
                                    <div
                                        className="intro_content inner_html"
                                        dangerouslySetInnerHTML={{ __html: codes }}></div>
                                </div>
                            ) : (
                                <div className="intro_page_wrap_null common_list">
                                    <div className="common_wrap">
                                        <h1>계획</h1>
                                        <h2>법규 현황, 설계 컨셉등 대한 계획을 확인할 수 있습니다.</h2>
                                        <Link
                                            to="/intro/detail"
                                            onClick={() => {
                                                ReactGA.event({ category: '하우스플랜', action: '설계도보기' })
                                            }}>
                                            <div className="upload_btn">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="14"
                                                    height="14"
                                                    viewBox="0 0 14 14">
                                                    <g fill="none" fillRule="evenodd" stroke="#24524A">
                                                        <rect
                                                            width="12.7"
                                                            height="12.7"
                                                            x=".65"
                                                            y=".65"
                                                            strokeWidth="1.3"
                                                            rx="2"
                                                        />
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeWidth="1.2"
                                                            d="M3.5 7h7M3.5 4.25h7M3.5 9.8h7"
                                                        />
                                                    </g>
                                                </svg>
                                                설계도 보기
                                            </div>
                                        </Link>
                                        <div className="no_project_wrap">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="55"
                                                height="63"
                                                viewBox="0 0 55 63">
                                                <defs>
                                                    <linearGradient
                                                        id="no_project1"
                                                        x1="50%"
                                                        x2="0%"
                                                        y1="50%"
                                                        y2="100%">
                                                        <stop offset="0%" stopColor="#E1E4EA" />
                                                        <stop offset="100%" stopColor="#D6D7DB" />
                                                    </linearGradient>
                                                    <path id="no_project2" d="M31 0v23h23z" />
                                                    <filter
                                                        id="no_project3"
                                                        width="113%"
                                                        height="113%"
                                                        x="-6.5%"
                                                        y="-6.5%"
                                                        filterUnits="objectBoundingBox">
                                                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                                                        <feGaussianBlur
                                                            in="shadowOffsetOuter1"
                                                            result="shadowBlurOuter1"
                                                            stdDeviation=".5"
                                                        />
                                                        <feColorMatrix
                                                            in="shadowBlurOuter1"
                                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                                        />
                                                    </filter>
                                                </defs>
                                                <g fill="none" fillRule="evenodd">
                                                    <path
                                                        fill="#E2E4E9"
                                                        d="M3 1h27.952L54 23.997V60a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3z"
                                                    />
                                                    <g
                                                        stroke="#F5F7FA"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2.4">
                                                        <path d="M37 32.733L17.733 52M17.733 32.733L37 52" />
                                                    </g>
                                                    <g transform="translate(0 1)">
                                                        <use
                                                            fill="#000"
                                                            filter="url(#no_project3)"
                                                            xlinkHref="#no_project2"
                                                        />
                                                        <use fill="url(#no_project1)" xlinkHref="#no_project2" />
                                                    </g>
                                                </g>
                                            </svg>
                                            <p>등록된 계획이 없습니다.</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap"></div>
            </div>
        )
    }
}

export default withCookies(IntroPage)



// WEBPACK FOOTER //
// ./Src/Containers/Intro/IntroPage.js